<div class="form-wrapper">
  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <div class="form-group" [class.with-error]="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
      <label for="email">User</label>
      <input matInput [errorStateMatcher]="matcher" id="email" inputmode="email" formControlName="email" type="email" placeholder="Enter Email">
    </div>
    <div class="error-wrapper" *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
      <mat-error *ngIf="emailControl.hasError('email') && !emailControl.hasError('required')">
        Please enter a valid email address
      </mat-error>
      <mat-error *ngIf="emailControl.hasError('required')">
        Email is required
      </mat-error>
    </div>
    <p class="text-center" *ngIf="ssoRequired">Your organisation signs in to Audalize with {{ providerLabel }}.</p>
    <ng-container *ngIf="!ssoRequired">
      <div class="form-group" [class.with-error]="passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)">
        <label for="password">Password</label>
        <input matInput [errorStateMatcher]="matcher" id="password" inputmode="password" formControlName="password" type="password" placeholder="Enter Password">
      </div>
      <div class="error-wrapper" *ngIf="passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)">
        <mat-error *ngIf="passwordControl.hasError('required')">
          Password is required
        </mat-error>
      </div>
    </ng-container>
    <div class="controls-wrapper">
      <div class="control-buttons">
        <button type="submit" [disabled]="loginForm.invalid || loginInProgress" class="btn signin-btn">
          {{ ssoRequired ? 'Continue with ' + providerLabel : 'Login' }}
        </button>
      </div>
      <div class="control-buttons" *ngIf="sso && !ssoRequired">
        <button type="button" [disabled]="loginInProgress" class="btn signin-btn" (click)="startSso()">
          Sign in with {{ providerLabel }}
        </button>
      </div>
      <a *ngIf="!ssoRequired" routerLink="./reset" class="d-block text-center forgot-link">Forgot password?</a>
    </div>
  </form>
</div>
